/* Takes an array of objects and returns an array of the specified field values */
export function arrayOfField(arr = [], field = null) {
    let newArr = arr.reduce((acc, item) => {
        if (!item) return acc;
        acc.push(item[field]);
        return acc;
    }, []);

    return newArr;
}

/* Compares 2 arrays for differences and returns and object with old (items not in the current array) and new (items not in the previous array) items */
export function getArrayDiff(current = [], previous = []) {
    let deletedFromOld = [];
    let addedToNew = [];

    current.forEach((itemCur) => {
        if (previous.indexOf(itemCur) === -1) {
            addedToNew.push(itemCur);
        }
    });

    previous.forEach((itemPrev) => {
        if (current.indexOf(itemPrev) === -1) {
            deletedFromOld.push(itemPrev);
        }
    });

    return {
        deleted: deletedFromOld,
        added: addedToNew
    };
}

export const compareSchema = {
    assets: {
        name: 'Assets',
        type: 'arrayOfObjects',
        displayField: 'filename',
        displayOnlyDiff: true,
        excludeFromList: true
    },
    title: {
        name: 'Title',
        type: 'string'
    },
    subtitle: {
        name: 'Subtitle',
        type: 'string'
    },
    series: {
        name: 'Series',
        type: 'string'
    },
    series_number: {
        name: 'Series Number',
        type: 'string'
    },
    description: {
        name: 'Description',
        type: 'string'
    },
    drm_required: {
        name: 'DRM Required',
        type: 'boolean',
        format: (value) => {
            if (value === null) {
                value = false;
            }
            return value.toString();
        }
    },
    publisher: {
        name: 'Publisher',
        type: 'string'
    },
    imprint: {
        name: 'Imprint',
        type: 'string'
    },
    authors: {
        name: 'Authors',
        type: 'array'
    },
    narrators: {
        name: 'Narrators',
        type: 'array'
    },
    translator: {
        name: 'Translator',
        type: 'string'
    },

    abridgement: {
        name: 'Abridgement',
        type: 'string'
    },
    awards: {
        name: 'Awards',
        type: 'array'
    },
    language: {
        name: 'Language',
        type: 'string'
    },
    territories_retail: {
        name: 'Territories',
        type: 'string',
        displayField: 'value'
    },
    runtime: {
        name: 'Runtime',
        type: 'string'
    },

    fiction_type: {
        name: 'Fiction/Non-Fiction',
        type: 'string'
    },
    grade_level: {
        name: 'Grade Level',
        type: 'string',
        warningMessage:
            'Changes to Grade Level are subject to manual review by INaudio and may not approved at the same time as other changes.'
    },
    bisac_codes: {
        name: 'BISAC',
        type: 'arrayOfObjects',
        displayField: 'literal',
        warningMessage:
            'Changes to BISAC codes are subject to manual review by INaudio and may not approved at the same time as other changes.'
    },

    isbn_retail: {
        name: 'Audiobook ISBN (Retail)',
        type: 'string'
    },
    isbn_library: {
        name: 'Audiobook ISBN (Library)',
        type: 'string'
    },
    isbn_ebook_retail: {
        name: 'eBook ISBN (Retail)',
        type: 'string'
    },
    isbn_ebook_library: {
        name: 'eBook ISBN (Library)',
        type: 'string'
    },
    isbn_print_retail: {
        name: 'Print ISBN (Retail)',
        type: 'string'
    },
    isbn_print_library: {
        name: 'Print ISBN (Library)',
        type: 'string'
    },
    price_retail: {
        name: 'Retail List Price (USD)',
        type: 'string',
        format: (value) => (value ? value.toFixed(2) : value)
    },
    price_library: {
        name: 'Library List Price (USD)',
        type: 'string',
        format: (value) => (value ? value.toFixed(2) : value)
    },
    currency: {
        name: 'Currency',
        type: 'string'
    },

    original_release_date: {
        name: 'Release Date',
        type: 'string'
    },
    strict_onsale_date: {
        name: 'Onsale Date',
        type: 'string'
    },
    audio_copyright_year: {
        name: 'Audio Copyright Year',
        type: 'string'
    },
    audio_copyright_owner: {
        name: 'Audio Copyright Owner',
        type: 'string'
    },
    source_copyright_year: {
        name: 'Source Copyright Year',
        type: 'string'
    },
    source_copyright_owner: {
        name: 'Source Copyright Owner',
        type: 'string'
    },
    simul_release: {
        name: 'Simultaneous Release with Print',
        type: 'boolean'
    },
    marketing_notes: {
        name: 'Marketing Notes',
        type: 'string'
    },
    per_circ_price: {
        name: 'Pay per Circ price',
        type: 'float'
    },
    keywords: {
        name: 'Keywords',
        type: 'array'
    }
};

export const makeMockItem = () => {
    return Object.keys(compareSchema)
        .map((key) => ({ ...compareSchema[key], key }))
        .reduce((obj, value) => {
            // if (value.type === 'string') {
            //     obj[value.key] = ''
            //     return obj;
            // }
            // if (value.type === 'array') {
            //     obj[value.key] = []
            //     return obj;
            // }
            obj[value.key] = null;
            return obj;
        }, {});
};

export function getPublishedDiff(schema, current, published) {
    let diffObj = {};

    for (const key in schema) {
        let curKey = schema[key];
        let hasChanged = false;
        let currentField = current[key] || null;
        let previousField = published[key] || null;
        let assetTypesChanged = [];
        let sortOrderChanged = false;

        switch (curKey.type) {
            case 'string':
            case 'number':
            case 'boolean':
            case 'float':
                if (currentField instanceof Array) {
                    currentField = currentField.join(',');
                }
                if (previousField instanceof Array) {
                    previousField = previousField.join(',');
                }
                if (currentField !== previousField) {
                    hasChanged = true;
                }
                break;
            case 'array':
                currentField = currentField || [];
                previousField = previousField || [];
                let comp = getArrayDiff(currentField, previousField);
                if (comp.deleted.length || comp.added.length) {
                    hasChanged = true;
                    currentField = (currentField || []).join(', ');
                    previousField = (previousField || []).join(', ');
                }
                break;
            case 'arrayOfObjects':
                currentField = currentField || [];
                previousField = previousField || [];
                let currentIds = arrayOfField(currentField, 'id');
                let previousIds = arrayOfField(previousField, 'id');
                let { added, deleted } = getArrayDiff(currentIds, previousIds);

                if (added.length || deleted.length) {
                    let currentDisplay = [];
                    let previousDisplay = [];

                    hasChanged = true;

                    if (curKey.displayOnlyDiff) {
                        (previousField || []).forEach((item) => {
                            if (deleted.indexOf(item.id) > -1) {
                                previousDisplay.push(item[curKey.displayField]);
                                assetTypesChanged.push(item.assettype);
                            }
                        });

                        (currentField || []).forEach((item2) => {
                            if (added.indexOf(item2.id) > -1) {
                                currentDisplay.push(item2[curKey.displayField]);
                                assetTypesChanged.push(item2.assettype);
                            }
                        });
                    } else {
                        currentDisplay = (currentField || [])
                            .map((item) => {
                                return item[curKey.displayField];
                            })
                            .join(', ');

                        previousDisplay = (previousField || [])
                            .map((item2) => {
                                return item2[curKey.displayField];
                            })
                            .join(', ');
                    }

                    previousField = previousDisplay;
                    currentField = currentDisplay;
                }

                if (!hasChanged && currentField.length === previousField.length) {
                    currentField
                        .filter((f) => f.groupoffset !== null)
                        .forEach((f, i) => {
                            const prevItem = previousField.find((i) => i.id === f.id);
                            if (f.groupoffset !== prevItem.groupoffset) {
                                sortOrderChanged = true;
                            }
                        });
                }
                break;
            default:
        }

        if (hasChanged) {
            diffObj[key] = {
                ...schema[key],
                name: schema[key].name,
                current: schema[key].format ? schema[key].format(currentField) : currentField,
                previous: schema[key].format ? schema[key].format(previousField) : previousField
            };

            if (key === 'assets') {
                diffObj[key].assetTypesChanged = assetTypesChanged;
            }

            if (schema[key].warningMessage) {
                diffObj[key].warningMessage = schema[key].warningMessage;
            }
        }

        if (sortOrderChanged) {
            diffObj.assetsOrderChange = {
                excludeFromList: true
            };
        }
    }

    return diffObj;
}
